import { designTokens } from "@itandi/itandi-bb-ui";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { useFormContext } from "react-hook-form";
import type { DealSettlementEdit } from "~/models/DealSettlement";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./SettlementForm.module.scss";

type Props = {
	onClickSubmit: () => void;
	type: "add" | "edit";
};

export function SettlementFormFooter({ type, onClickSubmit }: Props) {
	const {
		formState: { isSubmitting },
		watch
	} = useFormContext<DealSettlementEdit>();
	const totalAmount = watch("totalAmount");

	return (
		<Flex gap={designTokens["spacing/xs"]} padding={designTokens["spacing/s"]}>
			<Grid width="50%">
				<div className={Styles.TotalAmountView}>
					¥{toThousandSeparator(Number(totalAmount))}
				</div>
				<p className={Styles.Description}>※返還分はマイナス表示</p>
			</Grid>
			<Grid alignItems="center" width="50%">
				<Buttonv2
					disabled={isSubmitting}
					onClick={onClickSubmit}
					variant="secondary"
					width="fill"
				>
					{type === "add" ? "追加" : "更新"}
				</Buttonv2>
			</Grid>
		</Flex>
	);
}
